import React from "react";
import { render, hydrate } from "react-dom";
import App from "./components/App";
import { ColorContext, theme } from "./contexts/themeContext";

const rootElement = document.querySelector("#root");

if (rootElement.hasChildNodes()) {
  hydrate(
    <ColorContext.Provider value={theme}>
      <App />
    </ColorContext.Provider>,
    rootElement
  );
} else {
  render(
    <ColorContext.Provider value={theme}>
      <App />
    </ColorContext.Provider>,
    rootElement
  );
}
